import React, { useContext } from 'react'
import { motion } from 'framer-motion'
import { MenuContext } from 'contexts/Menu'
import { GeneralContext } from 'contexts/General'
import MenuItem from './MenuItem'

import {
  StyledMenuHeader,
  StyledMenuList,
  StyledMenuHeaderLi
} from './styles'


const variants = {
  open: {
    transition: {
      staggerChildren: 0.07, delayChildren: 0.2
    }
  },
  close: { transition: { staggerChildren: 0.07 } }
}

const variantsLi = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: {
        stiffness: 1000,
        velocity: -100
      }
    }
  },
  close: {
    opacity: 0,
    y: '100%',
    transition: {
      duration: 0.17,
      y: {
        stiffness: 1000,
        velocity: -100
      }
    }
  }
}

const MenuHeaderLi = ({
  idx,
  page,
  slug,
  separator,
  ...rest
}) => (
  <StyledMenuHeaderLi
    idx={idx}
    as={motion.li}
    separator={separator}
    initial={{
      y: 100,
      opacity: 0
    }}
    variants={variantsLi}
  >
    <MenuItem current={page && slug === page.slug || false} {...rest} />
  </StyledMenuHeaderLi>
)

const MenuHeader = () => {
  const {
    menus,
    menuOpen
  } = useContext(MenuContext)
  const menuHeader = [...menus.header]
  const { page } = useContext(GeneralContext)
  return (
    <StyledMenuHeader data-lenis-prevent>
      <StyledMenuList as={motion.ul} variants={variants} animate={menuOpen ? 'open' : 'close'}>
        {
          menuHeader
            .reverse()
            .map(({ items }, idx) => items.map(({
              id,
              slug,
              items: children,
              ...rest
            }, i) => (
              !!children
                ? children.map((item, index) => <MenuHeaderLi idx={idx} key={item.id} page={page} {...item} separator={idx === menus.header.length - 1 && index === 0}/>)
                : <MenuHeaderLi idx={idx} key={id} page={page} slug={slug} {...rest} separator={idx === menus.header.length - 1 && i === 0} />
            )))
        }
      </StyledMenuList>
    </StyledMenuHeader>
  )
}


export default MenuHeader
